var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { cssColorValue, IconArrowTopRight, Text, } from '@spotify-internal/encore-web/core';
import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { useS4AMastheadContext } from '../../S4AMastheadProvider';
import { icons } from '../../../utils/Icons';
import { ONE_COLUMN_MAX_WIDTH } from '../../NavBar/FlyoutMenu/MenuLayouts/Grid';
import { EASE, TIMEOUT_IN, TIMEOUT_OUT } from '../../NavBar/FlyoutMenu/config';
var ON_FOCUS_EASE = 'cubic-bezier(0, 0, 0, 1)';
var ON_FOCUS_TIME = '.45s';
var OFF_FOCUS_EASE = 'cubic-bezier(0, 0, 1, 0)';
var OFF_FOCUS_TIME = '.2s';
var visibleIcon = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  opacity: 100%;\n  [dir='ltr'] & {\n    padding-inline-start: ", ";\n  }\n  [dir='rtl'] & {\n    padding-inline-end: ", ";\n    padding-inline-start: 0px;\n  }\n"], ["\n  opacity: 100%;\n  [dir='ltr'] & {\n    padding-inline-start: ", ";\n  }\n  [dir='rtl'] & {\n    padding-inline-end: ", ";\n    padding-inline-start: 0px;\n  }\n"])), function (_a) {
    var size = _a.size;
    if (size === 'large') {
        return '8px';
    }
    if (size === 'medium') {
        return '6px';
    }
    return '4px';
}, function (_a) {
    var size = _a.size;
    if (size === 'large') {
        return '8px';
    }
    if (size === 'medium') {
        return '6px';
    }
    return '4px';
});
var withUnderline = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding-bottom: ", ";\n\n  background-image: ", ";\n\n  background-repeat: no-repeat;\n  background-size: ", ";\n  background-position-y: 100%;\n  background-position-x: 0%;\n  [dir='rtl'] & {\n    background-position-x: 100%;\n  }\n  transition: background-size ", " ", ",\n    background-position ", " ", ",\n    // color change transitions with flyout config\n    color cubic-bezier(", ") ", "ms;\n"], ["\n  padding-bottom: ", ";\n\n  background-image: ", ";\n\n  background-repeat: no-repeat;\n  background-size: ", ";\n  background-position-y: 100%;\n  background-position-x: 0%;\n  [dir='rtl'] & {\n    background-position-x: 100%;\n  }\n  transition: background-size ", " ", ",\n    background-position ", " ", ",\n    // color change transitions with flyout config\n    color cubic-bezier(", ") ", "ms;\n"])), function (_a) {
    var size = _a.size;
    if (size === 'large') {
        return '4px';
    }
    if (size === 'medium') {
        return '3px';
    }
    return '2px';
}, function (_a) {
    var color = _a.color;
    return color
        ? "linear-gradient(".concat(color, ", ").concat(color, ")")
        : "linear-gradient(".concat(cssColorValue('textBase'), ", ").concat(cssColorValue('textBase'), ")");
}, function (_a) {
    var size = _a.size;
    return size === 'large' || size === 'xlarge' ? '0% 4px' : '0% 2px';
}, OFF_FOCUS_EASE, OFF_FOCUS_TIME, OFF_FOCUS_EASE, OFF_FOCUS_TIME, EASE.join(', '), TIMEOUT_OUT);
var inFocus = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  outline: none;\n  // triggers the underline animation\n  background-size: ", ";\n  transition: background-size ", " ", ",\n    background-position ", " ", ",\n    // color change transitions with flyout config\n    color cubic-bezier(", ") ", "ms;\n\n  .newTabIcon {\n    // animates the new tab arrow from left to right\n    // and adds padding between it and the text\n    transition: all ", " ", ";\n    ", "\n  }\n"], ["\n  outline: none;\n  // triggers the underline animation\n  background-size: ", ";\n  transition: background-size ", " ", ",\n    background-position ", " ", ",\n    // color change transitions with flyout config\n    color cubic-bezier(", ") ", "ms;\n\n  .newTabIcon {\n    // animates the new tab arrow from left to right\n    // and adds padding between it and the text\n    transition: all ", " ", ";\n    ", "\n  }\n"])), function (_a) {
    var size = _a.size;
    return size === 'large' || size === 'xlarge' ? '100% 4px' : '100% 2px';
}, ON_FOCUS_EASE, ON_FOCUS_TIME, ON_FOCUS_EASE, ON_FOCUS_TIME, EASE.join(', '), TIMEOUT_IN, ON_FOCUS_EASE, ON_FOCUS_TIME, visibleIcon);
var TextLinkWrapper = styled.a.withConfig({
    shouldForwardProp: function (prop) {
        return !['showIcon', 'fullWidth', 'isFocus', 'color', 'size'].includes(prop);
    }
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  // override default link/button styling\n  text-decoration: none;\n  border: none;\n  color: ", ";\n  outline: none;\n  display: inline-block;\n  width: ", ";\n  background-color: unset;\n  padding: 0;\n  cursor: pointer;\n\n  ", "\n\n  &:focus-visible,\n  &:hover {\n    @media (hover: hover) {\n      ", "\n    }\n  }\n\n  ", "\n"], ["\n  // override default link/button styling\n  text-decoration: none;\n  border: none;\n  color: ", ";\n  outline: none;\n  display: inline-block;\n  width: ", ";\n  background-color: unset;\n  padding: 0;\n  cursor: pointer;\n\n  ", "\n\n  &:focus-visible,\n  &:hover {\n    @media (hover: hover) {\n      ", "\n    }\n  }\n\n  ", "\n"])), function (_a) {
    var color = _a.color;
    return color || cssColorValue('textBase');
}, function (_a) {
    var fullWidth = _a.fullWidth;
    return (fullWidth ? '100%' : 'fit-content');
}, withUnderline, inFocus, function (_a) {
    var isFocus = _a.isFocus;
    if (isFocus) {
        return inFocus;
    }
    return '';
});
var Content = styled.div.withConfig({
    shouldForwardProp: function (prop) { return !['fullWidth'].includes(prop); }
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  justify-content: ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  justify-content: ", ";\n"])), function (_a) {
    var fullWidth = _a.fullWidth;
    return fullWidth ? 'space-between' : 'unset';
});
var StyledText = styled(Text).withConfig({
    shouldForwardProp: function (prop) { return !['size', 'hasIcon'].includes(prop); }
})(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  line-height: normal;\n  text-align: start;\n  ", "\n\n  // override the encore font scaling to keep 40px\n  // for large links on mobile\n  @media (max-width: ", ") {\n    ", "\n  }\n"], ["\n  line-height: normal;\n  text-align: start;\n  ", "\n\n  // override the encore font scaling to keep 40px\n  // for large links on mobile\n  @media (max-width: ", ") {\n    ", "\n  }\n"])), function (_a) {
    var hasIcon = _a.hasIcon, size = _a.size;
    if (hasIcon) {
        return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        padding-inline-end: ", ";\n      "], ["\n        padding-inline-end: ", ";\n      "])), function () {
            if (size === 'large' || size === 'xlarge') {
                return '8px';
            }
            if (size === 'medium') {
                return '6px';
            }
            return '4px';
        });
    }
    return '';
}, ONE_COLUMN_MAX_WIDTH, function (_a) {
    var size = _a.size;
    return size === 'large'
        ? css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n            font-size: 40px;\n          "], ["\n            font-size: 40px;\n          "]))) : '';
});
var StyledIconArrowTopRight = styled(IconArrowTopRight)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n  opacity: 0%;\n  padding-inline-start: 0px;\n  padding-inline-end: 0px;\n  transition: padding-inline-start cubic-bezier(0, 0, 1, 0) 0.2s,\n    padding-inline-end cubic-bezier(0, 0, 1, 0) 0.2s,\n    opacity cubic-bezier(0, 0, 1, 0) 0.2s;\n\n  @media (hover: none) {\n    ", "\n  }\n"], ["\n  display: flex;\n  opacity: 0%;\n  padding-inline-start: 0px;\n  padding-inline-end: 0px;\n  transition: padding-inline-start cubic-bezier(0, 0, 1, 0) 0.2s,\n    padding-inline-end cubic-bezier(0, 0, 1, 0) 0.2s,\n    opacity cubic-bezier(0, 0, 1, 0) 0.2s;\n\n  @media (hover: none) {\n    ", "\n  }\n"])), visibleIcon);
var getTextVariant = function (size) {
    switch (size) {
        case 'xsmall':
            return 'bodySmallBold';
        case 'small':
            return 'bodyMediumBold';
        case 'medium':
            return 'titleSmall';
        case 'large':
            return 'titleLarge';
        case 'xlarge':
            return 'headlineMedium';
        default:
            return 'bodyMediumBold';
    }
};
export var TextLink = function (_a) {
    var label = _a.label, href = _a.href, trackingCategory = _a.trackingCategory, trackingLabel = _a.trackingLabel, color = _a.color, size = _a.size, _b = _a.openInNewTab, openInNewTab = _b === void 0 ? false : _b, svgIcon = _a.svgIcon, onClick = _a.onClick, onHover = _a.onHover, onKeyDown = _a.onKeyDown, onMouseDown = _a.onMouseDown, _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c, className = _a.className, isFocus = _a.isFocus;
    var Icon = svgIcon ? icons[svgIcon] : null;
    var getLinkProps = useS4AMastheadContext().getLinkProps;
    var props = href
        ? getLinkProps({
            trackingAttributes: [trackingCategory, trackingLabel, 'click'],
            href: href,
            openInNewTab: openInNewTab
        })
        : null;
    var anchorRef = useRef(null);
    return (React.createElement(TextLinkWrapper, __assign({ ref: anchorRef, color: color, isFocus: isFocus, className: className, size: size, fullWidth: fullWidth, showIcon: openInNewTab, tabIndex: 0 }, props, { onMouseEnter: onHover, onMouseOver: onHover, onFocus: onKeyDown, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onClick: function (e) {
            var _a, _b;
            (_a = props === null || props === void 0 ? void 0 : props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
            (_b = anchorRef.current) === null || _b === void 0 ? void 0 : _b.blur();
        }, as: href ? 'a' : 'button' }),
        React.createElement(Content, { fullWidth: fullWidth },
            React.createElement(StyledText, { hasIcon: svgIcon !== undefined || openInNewTab, size: size, variant: getTextVariant(size) }, label),
            Icon && React.createElement(Icon, { size: size === 'medium' ? 'small' : 'medium' }),
            openInNewTab && (React.createElement(StyledIconArrowTopRight, { className: "newTabIcon", size: size === 'medium' || size === 'small' ? 'small' : 'medium' })))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
